import React from 'react'
import { useLocation } from 'react-router-dom';
import MarketPlaceFeedNavbar from './MarketPlaceFeedNavbar';

const MarketPlaceSearchPage = () => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const search = query.get("search");
    const type = query.get("type");

  return (
    <>
     <MarketPlaceFeedNavbar  />
      Search Page {search} - {type}
    </>
  )
}

export default MarketPlaceSearchPage
